// Identifier scanners for local `$name` reference parsing.
// Example: `card-title` stays valid while trailing separators stop the scan.

// Check whether the current character can start an identifier.
export function isIdentifierStart(char: string): boolean {
  // RegExp matches `a` or `_` and returns true for valid identifier starts. Example: `a`.
  return /[a-zA-Z_]/.test(char)
}

// Check whether the current character can continue an identifier body.
export function isIdentifierBody(char: string): boolean {
  // RegExp matches `a`, `1`, or `_` and returns true for valid identifier body chars. Example: `x1`.
  return /[a-zA-Z0-9_]/.test(char)
}

// Resolve the index right after one identifier token with internal hyphen separators.
export function consumeIdentifier(source: string, start: number): number {
  let cursor = start
  // Check whether the current slice starts with a valid identifier character.
  if (!isIdentifierStart(source[cursor] ?? '')) {
    // Return the original start index for invalid identifier starts.
    return start
  } else {
    // Continue identifier token scanning.
  }

  cursor += 1
  // Consume identifier chars and allow only internal hyphen separators.
  while (cursor < source.length) {
    const char = source[cursor]
    const next = source[cursor + 1] ?? ''
    if (isIdentifierBody(char) || (char === '-' && isIdentifierBody(next))) {
      cursor += 1
    } else {
      // Stop identifier scan on non-identifier separators.
      break
    }
  }
  // Return the first index after the parsed identifier token.
  return cursor
}
